import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import URL from '../service/API_URL'
import './style.css'

const EssentialResult = () => {
  const navigate = useNavigate()
  const [result, setResult] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    const attemptId = sessionStorage.getItem('essential_attempt_id')
    const token = sessionStorage.getItem('essential_attempt_token')
    if (!attemptId || !token) { navigate('/', { replace: true }); return }
    URL.essentialAPI.get(`attempts/${attemptId}/result`, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => setResult(response.data.data))
      .catch((requestError) => setError(requestError.response?.data?.message || 'Your result could not be loaded.'))
  }, [navigate])

  const finish = () => {
    sessionStorage.removeItem('essential_attempt_id')
    sessionStorage.removeItem('essential_attempt_token')
    sessionStorage.removeItem('essential_candidate')
    navigate('/', { replace: true })
  }

  if (!result) return <main className="essential-shell essential-loading"><p>{error || 'Calculating your result…'}</p>{error && <button className="essential-primary" onClick={finish}>Back to home</button>}</main>

  return <main className="essential-shell essential-result-page"><section className="essential-result-card essential-submitted-card"><div className="essential-success-mark" aria-hidden="true">✓</div><span className="essential-kicker">TEST SUBMITTED</span><h1>Congratulations—you finished!</h1><p className="essential-lead">Your Listening, Reading, and Writing responses are safely submitted. The NIEC team will review your complete test before preparing your final result.</p><div className="essential-review-steps"><div><strong>1</strong><span>Submission received</span></div><div><strong>2</strong><span>Writing reviewed by NIEC</span></div><div><strong>3</strong><span>Final result shared with you</span></div></div><p className="essential-result-note">No score is shown immediately because your Writing response requires review.</p><button className="essential-primary" type="button" onClick={finish}>Back to home</button></section></main>
}

export default EssentialResult
